"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SupportId = require("./SupportId");
Object.keys(_SupportId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SupportId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SupportId[key];
    }
  });
});
